import { render, staticRenderFns } from "./AreaCreate.vue?vue&type=template&id=3da6e664&"
import script from "./AreaCreate.vue?vue&type=script&lang=js&"
export * from "./AreaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports